var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5515 0.977266C12.2462 0.674245 11.7536 0.674245 11.4483 0.977265L8.2093 4.1919C8.06117 4.33892 7.97786 4.53899 7.97786 4.74769V6.10773H2.28293C1.85046 6.10773 1.49988 6.45831 1.49988 6.89078V21.8924C1.49988 22.3249 1.85046 22.6755 2.28293 22.6755H21.7169C22.1493 22.6755 22.4999 22.3249 22.4999 21.8924V11.177C22.4999 10.7445 22.1493 10.3939 21.7169 10.3939H16.0219V4.74769C16.0219 4.53899 15.9386 4.33892 15.7905 4.1919L12.5515 0.977266ZM9.54396 6.89078V5.07377L11.9999 2.6363L14.4558 5.07377V11.177C14.4558 11.6094 14.8064 11.96 15.2389 11.96H20.9338V21.1094H3.06598V7.67384H8.76091C9.19338 7.67384 9.54396 7.32325 9.54396 6.89078ZM6.59606 19.7453H4.43674V17.6022H6.59606V19.7453ZM6.59606 15.4591H4.43674V13.316H6.59606V15.4591ZM6.59606 11.1729H4.43674V9.02979H6.59606V11.1729ZM10.9147 19.7453V17.6022H13.074V19.7453H10.9147ZM10.9147 15.4591V13.316H13.074V15.4591H10.9147ZM10.9147 11.1729V9.02979H13.074V11.1729H10.9147ZM10.9147 6.8867V4.74361H13.074V6.8867H10.9147ZM19.552 19.7453H17.3927V17.6022H19.552V19.7453ZM19.552 15.4591H17.3927V13.316H19.552V15.4591Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/Participants.81cc1d6675de6c553ba40323b21b521c.svg";
export { ForwardRef as ReactComponent };